import _extends from "@babel/runtime/helpers/extends";
import { layers } from "@smartsheet/design-tokens";
import { Portal, getThemeClasses, useTheme } from "@smartsheet/lodestar-core";
import clsx from "clsx";
import React, { useCallback, useEffect, useState } from "react";
import { ToastContainer } from "../components/ToastContainer";
import { ToasterStyled } from "../styled/ToasterStyled";
export const Toaster = _ref => {
  let {
    clientId,
    manager,
    sdsProviderProps,
    sdsProviderStyles,
    ...rest
  } = _ref;
  const [toastQueue, setToastQueue] = useState([]);
  const [registrationCallbacks, setRegistrationCallbacks] = useState(null);
  const [heightMap, setHeightMap] = useState(() => new Map());
  const toastsToShow = toastQueue
  // Don't render the pending ones - those need to be out of the DOM until the
  // toast is queued so the animation starts from the top, not their current
  // location in the stack.
  .filter(entry => entry.status !== "pending");
  const offsets = toastsToShow.reduce((arr, toastEntry) => {
    const thisElementHeight = heightMap.get(toastEntry.id)?.height ?? 0;
    const offset = arr[arr.length - 1] + thisElementHeight;
    arr.push(offset);
    return arr;
  },
  // Start with 0 since the first toast's offsets is always 0. The second toast's offset is
  // the first one's height.
  [0]);

  // Need to memoize this since it's used in a resizeobserver which needs a memoized callback to
  // perform efficiently.
  const updateHeight = useCallback((id, element) => {
    setHeightMap(oldMap => {
      const oldHeight = oldMap.get(id)?.height ?? 0;
      if (oldHeight === element.offsetHeight) {
        return oldMap;
      }
      const newMap = new Map(oldMap);
      newMap.set(id, {
        element,
        height: element.offsetHeight
      });
      return newMap;
    });
  }, []);

  // Set up state service subscription.
  useEffect(() => {
    const registerHandle = manager.registerToaster({
      setToastQueue
    });
    setRegistrationCallbacks(registerHandle);
    return () => {
      registerHandle.unregister();
    };
  }, [manager]);
  const {
    key
  } = useTheme();
  const themeMode = key;
  const {
    className,
    ...restProps
  } = rest;
  const combinedClassName = clsx(getThemeClasses(themeMode), className); //this enables custom classNames while still including required theme classNames

  return toastsToShow.length ? /*#__PURE__*/React.createElement(Portal, {
    zIndex: layers.toast
  }, /*#__PURE__*/React.createElement(ToasterStyled, _extends({
    "data-client-id": clientId,
    className: combinedClassName
  }, restProps), toastsToShow.map((entry, i) => {
    return /*#__PURE__*/React.createElement(ToastContainer, {
      key: entry.id,
      entry: entry,
      offset: offsets[i] ?? 0,
      updateHeight: updateHeight,
      triggerFadeOut: () => {
        registrationCallbacks?.removeToast(entry.id);
      },
      pauseAutoCloseTimers: () => {
        manager.pauseAutoRemove();
      },
      restartAutoCloseTimers: () => {
        manager.restartAutoRemove();
      },
      sdsProviderProps: sdsProviderProps,
      sdsProviderStyles: sdsProviderStyles
    });
  }))) : null;
};
//# sourceMappingURL=Toaster.js.map